import React, {useState} from "react";
import {List, TextField} from "@mui/material";
import Box from "@mui/material/Box";

export interface SearchableListProps<ListT> {
    list: ListT[];
    render(e: ListT, i: number, search: string): any;
    element_matches(e: ListT, search: string): boolean;
}

export function SearchableList<ListT>(props: SearchableListProps<ListT>) {
    const [search, set_search] = useState("");

    return <div>
        <Box padding={1}>
            <TextField id="list_search"
                       label="Search"
                       fullWidth
                       variant="outlined"
                       margin="normal"
                       placeholder="Type to search"
                       value={search}
                       onChange={e => set_search(e.target.value)}/>
        </Box>
        <List>
            {props.list.map((element: ListT, i: number) => {
                const search_lower = search.toLowerCase();
                if (search.length === 0 || props.element_matches(element, search_lower)) {
                    return props.render(element, i, search_lower)
                }
                return undefined;
            })}
        </List>
    </div>
}